export const fontFamilyNames = {
  brand: 'Inq',
} as const;

export const fontFamilies = {
  brand: `"${fontFamilyNames.brand}", sans-serif`,
} as const;

export const fontFamilyCssVariables = {
  brand: '--blinq-font-family-brand',
} as const;

export const fontFamilyVarReferences = {
  brand: `var(${fontFamilyCssVariables.brand})`,
} as const;

export const fontWeights = {
  regular: '500',
  demibold: '600',
  bold: '700',
} as const;

const toFontSrc = (sources: string[]) => sources.join(', ');

export const brandFontAssets = {
  regular: {
    src: toFontSrc([
      'url("/fonts/Inq-Regular.woff2") format("woff2")',
      'url("/fonts/Inq-Regular.woff") format("woff")',
      'url("/fonts/Inq-Regular.otf") format("opentype")',
    ]),
    weight: fontWeights.regular,
  },
  medium: {
    src: toFontSrc([
      'url("/fonts/Inq-Medium.woff2") format("woff2")',
      'url("/fonts/Inq-Medium.woff") format("woff")',
      'url("/fonts/Inq-Medium.otf") format("opentype")',
    ]),
    weight: fontWeights.demibold,
  },
  demibold: {
    src: toFontSrc([
      'url("/fonts/Inq-DemiBold.woff2") format("woff2")',
      'url("/fonts/Inq-DemiBold.woff") format("woff")',
      'url("/fonts/Inq-DemiBold.otf") format("opentype")',
    ]),
    weight: fontWeights.bold,
  },
} as const;

export const newBrandFonts = {
  marist: {
    familyName: 'Inq Marist',
    family: `"Inq Marist", "${fontFamilyNames.brand}", serif`,
    src: toFontSrc([
      'url("/fonts/InqMarist-SemiBold.woff2") format("woff2")',
      'url("/fonts/InqMarist-SemiBold.woff") format("woff")',
    ]),
    weight: fontWeights.demibold,
  },
  antiqueLegacy: {
    familyName: 'Antique Legacy',
    family: '"Antique Legacy", Georgia, serif',
    src: toFontSrc([
      'url("/fonts/Antique-Legacy-Regular.woff2") format("woff2")',
      'url("/fonts/Antique-Legacy-Regular.woff") format("woff")',
    ]),
    weight: '400',
  },
  antiqueLegacyMedium: {
    familyName: 'Antique Legacy',
    family: '"Antique Legacy", Georgia, serif',
    src: toFontSrc([
      'url("/fonts/Antique-Legacy-Medium.woff2") format("woff2")',
      'url("/fonts/Antique-Legacy-Medium.woff") format("woff")',
    ]),
    weight: '500',
  },
} as const;
